<div *appInjectHeader="currentHeader$ | async"></div>
